/* eslint-disable react/sort-comp,react/jsx-handler-names */
import React from 'react';
import PropTypes from 'prop-types';

export class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidCatch(error) {
    this.setState(error);

    console.log('ERROR HAPPENED', error);
  }

  openReportDialog = () => {
    console.log('show sentry dialog');
  };

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <button type="button" onClick={this.openReportDialog}>
          <p>We&apos;re sorry — something&apos;s gone wrong.</p>
          <p>
            Our team has been notified, but click here to fill out a report.
          </p>
        </button>
      );
    }
    return children;
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/index.jsx